/**
 * @generated SignedSource<<1793e182442f661d3f5066b43ddbb9cc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type SideGeneratorBulkInput = {
  aspectRatio?: string | null;
  model?: string | null;
  prompt: string;
  sides: ReadonlyArray<SideGeneratorBulkItemInput>;
};
export type SideGeneratorBulkItemInput = {
  reference?: string | null;
  sideImageUrl?: string | null;
};
export type sideGeneratorBulkStartMutation$variables = {
  input: SideGeneratorBulkInput;
};
export type sideGeneratorBulkStartMutation$data = {
  readonly startSideGeneratorBulk: {
    readonly items: ReadonlyArray<{
      readonly reference: string | null;
      readonly state: AIStudioTaskState;
      readonly taskId: number;
    }>;
  };
};
export type sideGeneratorBulkStartMutation = {
  response: sideGeneratorBulkStartMutation$data;
  variables: sideGeneratorBulkStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SideGeneratorBulkTask",
    "kind": "LinkedField",
    "name": "startSideGeneratorBulk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SideGeneratorBulkTaskItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reference",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sideGeneratorBulkStartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sideGeneratorBulkStartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "ec7f385be74cf905b03ac2656f8e6112",
    "id": null,
    "metadata": {},
    "name": "sideGeneratorBulkStartMutation",
    "operationKind": "mutation",
    "text": "mutation sideGeneratorBulkStartMutation(\n  $input: SideGeneratorBulkInput!\n) {\n  startSideGeneratorBulk(input: $input) {\n    items {\n      reference\n      taskId\n      state\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc462eb15bcc575b39002098a186f20b";

export default node;
